import { observer } from 'mobx-react-lite';
import style from '../SimpleTacticStyle.module.css';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { Body3, Body4, fontSizes } from '../../../../../../../atomic/text/Text';
import { colors } from '../../../../../../../../colorVars';
import { NumericalInput } from '../../../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';


export const SimpleUnderlyingPriceTrail = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const defaultFn = () => {};
  const isEnabled = tradePlanForm.exitTactics.UNDERLYING_PRICE_TRAIL ?? false;
  const amount = tradePlanForm.exitTactics.UNDERLYING_PRICE_TRAIL?.amount ?? 0;
  const setAmount =
    tradePlanForm.exitTactics.UNDERLYING_PRICE_TRAIL?.setAmount ?? defaultFn;

  return (
    <div className={style.container}>
      <div className={style.labelAndCheckbox}>
        <input
          style={{ margin: '0 5px 0 0' }}
          type="checkbox"
          checked={isEnabled}
          onChange={() => {
            if (isEnabled) {
              tradePlanForm.removeExitTactic('UNDERLYING_PRICE_TRAIL');
            } else {
              tradePlanForm.addExitTactic('UNDERLYING_PRICE_TRAIL');
            }
          }}
        />
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Underlying Price Trail
        </Body3>
      </div>
      <div className={style.controls}>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Amount</Body4>
          <NumericalInput
            disabled={!isEnabled}
            width="50px"
            maxHeight="23px"
            icon="$"
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={amount}
            onChange={setAmount}
          />
        </div>
      </div>
    </div>
  );
});
